export { default as NotificationView } from './NotificationView';
